import { sliderDotsAnimation } from '../utilities/slider-dots-animation'
import { breakpoint } from '../utilities/screen_setup'

let drone_slider = $('.drone-slider-init')
if (drone_slider.length) {
  let drone_slider_slick = drone_slider.slick({
    infinite: true,
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '18vw',
    useTransform: false,
    responsive: [
      {
        breakpoint: breakpoint('md'),
        settings: {
          dots: true,
          centerPadding: '5vw',
        },
      },
      {
        breakpoint: breakpoint('sm'),
        settings: {
          dots: true,
          centerPadding: '3vw',
        },
      },
    ],
  })

  $('body').on('click', '.drone-slider-arrows a[data-slick-move]', function (e) {
    e.preventDefault()
    drone_slider_slick.slick($(this).attr('data-slick-move'))
  })

  drone_slider_slick.on('beforeChange',
    function (event, slick, currentSlide, nextSlide) {
      let dots = $(this).closest('section').find('.js-dots')
      sliderDotsAnimation(dots, currentSlide, nextSlide)
    })

}
